<template>
  <div>
  <UserGuidVue :picsdata="pics">
      </UserGuidVue>
  </div>
</template>

<script>
import UserGuidVue from '../components/UserGuid.vue'

export default {
  name: 'Huawei',
  data () {
    return {
      pics: [
        { url: require('../assets/huawei1.png'), text: '点击设置（在应用程序或弹出的菜单中找到设置' },
        { url: require('../assets/huawei2.png'), text: '点击关于设备(关于手机或关于平板电脑)' },
        { url: require('../assets/huawei3.png'), text: '连续点击系统版本（例如：Legion OS）4-8次' },
        { url: require('../assets/huawei4.png'), text: '返回设置,打开开发者选项' },
        { url: require('../assets/huawei5.png'), text: '打开USB调试' }
      ]
    }
  },
  components: {
    UserGuidVue
  }
}
</script>

<style>

</style>
